<template>
  <div class="m-page m-page-about">
    <section class="m-about-section" aria-labelledby="about-intro-title">
      <h1 id="about-intro-title">平台简介</h1>
      <div class="m-about-card">
        <p>化化网是深圳市化化科技有限公司旗下的城乡更新公开履单平台，专注为城市住宅装修、商业空间装修、局改修缮、农村自建房翻新与新建提供一站式保障服务。</p>
        <p>平台以“先做后付、信息透明、在线履约、平台托底”为核心机制，构建了完善的信用体系与交易保障体系，致力于提升行业信息透明度与信任度，为业主打造安心、省心、可信赖的服务体验。</p>
        <p>化化网旗下拥有自营装修建房品牌“化化自营”，由具备设计与施工资质的中迈致远建设集团作为核心承担者，为业主提供从设计、施工到交付的全过程服务。化化自营作为平台托底保障的核心承担者，始终恪守不转包、不分包的直营承诺。一线施工团队长期磨合、高度协同；材料统一采购，严控源头品质；工艺执行统一标准，规范全程作业；验收实施统一把关，层层压实责任，实现端到端全程闭环管控。以全链条自主可控的坚实能力，确保交付品质与托底保障万无一失。</p>
        <p>平台面向优质设计机构、装企等企业服务商，以及设计师、造价师、项目经理、工人等个人服务商全面开放，共同服务城乡多元空间更新需求。</p>
      </div>
    </section>

    <section class="m-about-section" aria-labelledby="about-meaning-title">
      <h2 id="about-meaning-title">化化名字的寓意</h2>
      <div class="m-about-card">
        <p>《周易》贲卦、彖传：“刚柔交错，天文也；文明以止，人文也。观乎天文，以察时变；观乎人文，以化成天下。”</p>
        <p>中华文化上下五千年不断，有着非常强大的民族向心力，东西文化相比，中国文化强调人的主体性、独立性、能动性及中华之“士”的精神，不是靠一个外在的神或造物主，而是靠人的自觉与自律，这是中国文化的核心。</p>
        <p>“化化”要传达的就是这种文化核心，这是第一个“化”的意思，第二个化是“化解、化成”之义，只要遵照第一个“化”，我们相信任何纠纷、问题都能化解，任何梦想都能化成现实，这也是我们搭建这个平台的意义。</p>
      </div>
    </section>

    <section class="m-about-section" aria-labelledby="about-contact-title">
      <h2 id="about-contact-title">联系我们</h2>
      <!-- <address class="m-about-card m-contact-card">
        <h3>深圳市化化科技有限公司</h3>
        <p><span>地址：</span>深圳市福田区深南大道6033号金运世纪大厦8B</p>
        <p><span>客服电话：</span><a href="tel:075586029999">0755-86029999</a></p>
        <p><span>服务时间：</span>周一到周五 9:00-18:00</p>
      </address> -->
      <img
        class="m-contact-map"
        src="https://obs.huahuaeco.com/official/AboutM/img3.png"
        alt="深圳市化化科技有限公司地址地图：深圳市福田区深南大道6033号金运世纪大厦8B"
        loading="lazy"
      />
    </section>
    <SeoStaticImages :images="seoImages" />
  </div>
</template>

<script>
import { useHead } from '@unhead/vue'
import { getPageHead } from '../../utils/page-head'
import SeoStaticImages from '../../components/SeoStaticImages.vue'

export default {
  name: 'AboutMobilePage',
  components: {
    SeoStaticImages
  },
  setup() {
    useHead(getPageHead('about', 'https://www.huahuaeco.com/about'))
  },
  data() {
    return {
      seoImages: [
        'https://obs.huahuaeco.com/official/AboutM/img3.png'
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.m-page {
  min-height: 100vh;
  padding: calc(88 * var(--rpx)) calc(32 * var(--rpx)) calc(56 * var(--rpx));
  background: #f4f7fb;
  overflow: hidden;
}

.m-about-section {
  padding-top: calc(44 * var(--rpx));

  h1,
  h2 {
    margin: 0;
    color: #262626;
    font-size: calc(40 * var(--rpx));
    font-weight: 700;
    line-height: 1.35;
  }
}

.m-about-card {
  margin-top: calc(40 * var(--rpx));
  padding: calc(42 * var(--rpx)) calc(42 * var(--rpx));
  border-radius: calc(24 * var(--rpx));
  background: #fff;
  box-shadow: 0 calc(20 * var(--rpx)) calc(40 * var(--rpx)) rgba(224, 229, 238, 0.2);

  p {
    margin: 0 0 calc(34 * var(--rpx));
    color: #8c8c8c;
    font-size: calc(26 * var(--rpx));
    line-height: 1.72;
    text-align: left;
  }

  p:last-child {
    margin-bottom: 0;
  }
}

.m-contact-card {
  font-style: normal;

  h3 {
    margin: 0 0 calc(28 * var(--rpx));
    color: #262626;
    font-size: calc(34 * var(--rpx));
    font-weight: 700;
    line-height: 1.4;
  }

  p {
    color: #595959;
  }

  span {
    color: #8c8c8c;
  }

  a {
    color: inherit;
    text-decoration: none;
  }
}

.m-contact-map {
  display: block;
  width: 100%;
  height: auto;
  margin-top: calc(28 * var(--rpx));
  border-radius: calc(24 * var(--rpx));
  box-shadow: 0 calc(20 * var(--rpx)) calc(40 * var(--rpx)) rgba(224, 229, 238, 0.2);
}

@media (min-width: 560px) {
  .m-page {
    padding-left: calc(56 * var(--rpx));
    padding-right: calc(56 * var(--rpx));
  }
}
</style>
